module.exports = __webpack_public_path__ + "fonts/5d3bff6a53e489affefa6bda85b4fe92-Roboto-BoldItalic.eot";